module.exports = __webpack_public_path__ + "img/bg4.42b2ce0f.png";